import React, { useContext } from 'react';
import 'twin.macro';
import { CommentsContext, ModerationContext, UserContext } from '../context';
import { CopyUrl } from '../actions';
import { replaceStringURLs, timeStampLink, replaceNewlinesWithBreaks } from '../../lib/helpers';
import { Paragraph } from '../text';

export const CommentContent = ({ comment, subComment }) => {
  const { user } = useContext(UserContext);
  const { itemId, item } = useContext(CommentsContext);
  const { moderationState } = useContext(ModerationContext);
  const userCanModerate = user && user.moderate;
  const commentRemoved = userCanModerate && moderationState.removedList.includes(comment.id);
  const commentBanned = userCanModerate && moderationState.bannedList.includes(comment.id);
  const { moderated_by: moderatedBy, banned, id, content } = comment;
  const formattedContent = replaceNewlinesWithBreaks(content);

  return (
    <>
      {moderatedBy && (commentRemoved || commentBanned) && (
        <small tw='block mb-1 opacity-50 italic'>
          {banned ? 'gebanned' : 'weggejorist'} door {moderatedBy}
        </small>
      )}
      <div tw='flex w-full justify-between break-normal'>
        <Paragraph
          dangerouslySetInnerHTML={{
            __html: replaceStringURLs(timeStampLink(formattedContent, itemId, item)),
          }}
          tw='opacity-100 w-[calc(100%-1.75rem)] break-words'
        />
        {!subComment && (
          <CopyUrl
            isComment
            path={`/item/${itemId}#comment${id}`}
            tw='
          mr-2
          opacity-100
          lg:opacity-0
          lg:pointer-events-none
          lg:transition-all
          lg:group-hover:opacity-100
          lg:group-hover:pointer-events-auto'
          />
        )}
      </div>
    </>
  );
};
